// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
// import apiConfig from '../config/api.config.js'
import 'element-ui/lib/theme-chalk/index.css'
import {Message, Carousel, CarouselItem, InfiniteScroll} from 'element-ui'
import request from './service/index'
import {VisitType} from './constant'
import {LogUtils, isMobileAgent, Storage} from '@/utils'
import config from '../static/config/config'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'EN', // todo 使用版本
  fallbackLocale: 'EN',
  messages: { // todo 配置不同版本
    'EN': require('./assets/locale/en-US.js'),
    'IN': require('./assets/locale/hi-IN.js'),
    'ZH': require('./assets/locale/zh-CN.js'),
    'VN': require('./assets/locale/vi-VN.js')
  }
})

Vue.use(Carousel).use(CarouselItem).use(InfiniteScroll)
Vue.prototype.$message = Message

// axios.defaults.baseURL = apiConfig.baseURL
axios.defaults.baseURL = config.baseURL // 2021-08-08 C0025 Add

Vue.config.productionTip = false

/***
 * Execute something when enter each router
 * ......
 * 2021-06-08 CHP Add logic to send visit log to server
 * 2021-10-23 LBL Add url parameter when jumping to app
 * 2021-10-25 CHP 根据用户特性决定用户所属国家版本
 * 2021-10-31 CHP 增加setShowInternationDDL判断是否需要显示国家列表
 */
router.beforeEach((to, from, next) => {
  if (isMobileAgent()) {
    let fullPath = to.fullPath
    let index = fullPath.indexOf('?')
    let params = fullPath.substring(index)
    if (to.query.rv) {
      if (location.hostname.startsWith('uat')) {
        window.location.href = 'https://uat-app.pgebet.com/login' + params
      } else {
        let firstDotIndex = location.hostname.indexOf('.') // 查找第一个 "." 的索引位置
        let result = location.hostname.substring(firstDotIndex + 1)// 截取从第一个 "." 到末尾的部分
        result = result.replace('/', '')
        window.location.href = 'https://app.' + result + '/login' + params
      }
    } else {
      if (location.hostname.startsWith('uat')) {
        window.location.href = 'https://uat-app.pgebet.com' + params
      } else {
        let firstDotIndex = location.hostname.indexOf('.') // 查找第一个 "." 的索引位置
        let result = location.hostname.substring(firstDotIndex + 1)// 截取从第一个 "." 到末尾的部分
        result = result.replace('/', '')
        window.location.href = 'https://app.' + result + params
      }
    }
  }

  // location.search.split('cid=')[1] && localStorage.setItem('cid', location.search.split('cid=')[1])
  // 2021-10-07 C007 Get cid from query string
  if (to.query.cid) {
    // 2022-02-20 CHP Cid统一转为小写
    let cidQ = to.query.cid.toLowerCase()
    // 2022-05-10 CHP 来自PartnerMatrix的cid为xxxx_xxxx,只取前半部分
    if (cidQ.indexOf('_') > 0) {
      let cidQL = cidQ.split('_')
      if (cidQL.length > 0) {
        cidQ = cidQL[0]
      }
    }
    localStorage.setItem('cid', cidQ)
  }

  let cid = localStorage.getItem('cid') // 注：从localstorage取出cid）

  // 初始化 Facebook Pixel
  const pixelId = determinePixelId()
  initFacebookPixel(pixelId)

  // START: 2021-10-25 CHP 获取国家版本和语言
  setInternation()
  // END: 2021-10-25 CHP 获取国家版本和语言

  // GOOGLE 统计
  window.gtag('config', 'UA-181768658-1', {'page_path': location.pathname})
  window.gtag('event', 'Visits', {
    'event_category': location.pathname,
    'event_label': cid
  })
  // GOOGLE 统计

  // CHEN PU: Add code to log visit onto server
  const url = '/innovation/log/logvisit'
  const visitorCode = LogUtils.getVisitorCode()
  const userUniqueId = LogUtils.getUserUniqueIdLocal()
  const data = {
    visitorCode: visitorCode,
    userUniqueId: userUniqueId,
    campaignId: cid,
    visitType: VisitType.Visit,
    pagePath: location.pathname
  }

  request('post', url, data).then(res => {
  }).catch((e) => {

  })

  store.commit('setShowWinner', true)

  window.scrollTo(0, 0)
  // 如果路由有meta.title，则更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Best Online Casino & Sports Betting in India PGEBet'
  }

  // 更新其他meta信息（例如 description, keywords）
  if (to.meta.description) {
    const description = document.querySelector('meta[name="description"]')
    if (description) {
      description.setAttribute('content', to.meta.description)
    }
  } else {
    const description = document.querySelector('meta[name="description"]')
    if (description) {
      description.setAttribute('content', 'PGEBet India 🎰: Play 500+ Real Money Casino Games & Bet on IPL, Cricket & Football! Claim Your ₹5,000 Welcome Bonus + Free Spins. Secure & Legal!')
    }
  }
  if (to.meta.keywords) {
    const keywords = document.querySelector('meta[name="keywords"]')
    if (keywords) {
      keywords.setAttribute('content', to.meta.keywords)
    }
  } else {
    const keywords = document.querySelector('meta[name="keywords"]')
    if (keywords) {
      keywords.setAttribute('content', 'Online Casino India,IPL Betting,Real Money Games,Welcome Bonus India')
    }
  }
  if (to && to.name) {
    let name = to.name.toLowerCase() === 'home' ? 'PageViewHome' : to.name
    LogUtils.fbListener(name)
  }
  next()
})

/***
 * 设置国家版本
 * 2022-06-21 CHP 重构
 * 2023-05-24 WXJ 新需求
 */
const setInternation = function () {
  let locale = Storage.getExpire('locale')
  let internation = ''
  if (!locale) {
    locale = navigator.language.toUpperCase()
    if (locale === 'HI') {
      locale = 'IN'
    }
    if (locale !== 'EN' || locale !== 'IN') {
      locale = 'EN'
    }
  } else {
    locale = Storage.getExpire('locale')
    Storage.setExpire('locale', locale, 30 * 24 * 60 * 60)
  }
  internation = 'IN'
  if (locale === 'IN') {
    internation = 'IN'
  }
  store.commit('setInternation', internation)
  // store.commit('setInternationName', res.InternationName)
  store.commit('setLocale', locale)
  i18n.locale = locale
  console.log('i18n locale: ', i18n.locale)
}

// 定义 Facebook Pixel 初始化函数
function initFacebookPixel (pixelId) {
  // Facebook Pixel 初始化代码
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  // 初始化 Pixel
  window.fbq('init', pixelId)
}

// 动态选择 Pixel ID
function determinePixelId () {
  // Pixel ID
  const cid = localStorage.getItem('cid')
  // 根据 cid 选择 Pixel ID
  if (cid && cid === '9af1ep') {
    return '470730042764100'
  }
  return '470730042764100'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js